import type { IconSvgObject } from './types';

const Grid2X2XIcon: IconSvgObject = [
  ["path", { d: "M11.7539 20.75H4.75391C3.64934 20.75 2.75391 19.8546 2.75391 18.75V4.75C2.75391 3.64543 3.64934 2.75 4.75391 2.75H18.7539C19.8585 2.75 20.7539 3.64543 20.7539 4.75V11.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.2378 16.25L18.7461 18.7458M18.7461 18.7458L16.2461 21.25M18.7461 18.7458L21.2461 21.25M18.7461 18.7458L16.2544 16.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.7539 2.75V20.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20.7598 11.7422H2.75977", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Grid2X2XIcon;
